import React from 'react';
import Nav from '../../components/Nav';

export default function ProTiers() {
  const tiers = [
    {
      name: 'Free',
      price: '$0/month',
      features: [
        'Access to a limited selection of courses',
        'Basic software tools',
        'Low-resolution image collections',
        'Basic printable drawings for kids',
        'Community Support',
      ],
      button: 'Start for Free',
      mostPopular: false,
    },
    {
      name: 'Essential',
      price: '$12/month',
      features: [
        'Access to premium courses',
        'Advanced software tools',
        'High-resolution image collections',
        'Exclusive printable designs for kids',
        'Priority Email Support',
      ],
      button: 'Upgrade to Essential',
      mostPopular: false,
    },
    {
      name: 'Plus',
      price: '$29/month',
      features: [
        'All Essential features',
        'Custom Branding for printables',
        'Download Management Tools',
        'Progress tracking for courses',
        'Detailed Analytics (User Engagement, Downloads)',
        'Ad-Free Experience',
        'Priority Support',
      ],
      button: 'Go Plus',
      mostPopular: true,
    },
    {
      name: 'Ultimate',
      price: '$59/month',
      features: [
        'All Plus features',
        'Dedicated Account Manager',
        'Certificate Generation for completed courses',
        'Custom API Access',
        'Real-Time Analytics',
        '24/7 Premium Support',
      ],
      button: 'Contact Us',
      mostPopular: false,
    },
  ];

  return (
    <div>
      <Nav/>
      <main className="bg-white min-h-screen">
        <div className="max-w-7xl mx-auto py-16 px-6 sm:px-8 lg:px-12">
          <h2 className="text-4xl font-extrabold text-gray-900 text-center">
            Unlock the Full Experience
          </h2>
          <p className="mt-6 text-lg text-gray-600 text-center max-w-2xl mx-auto">
            Enjoy free access to our offerings or upgrade to Pro plans for premium content and tools across courses, software, image collections, and printables.
          </p>
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {tiers.map((tier, index) => (
              <div
                key={index}
                className={`relative bg-white border ${
                  tier.mostPopular
                    ? 'border-pink-500 ring-2 ring-pink-500'
                    : 'border-gray-200'
                } rounded-[35px] shadow-xl overflow-hidden`}
              >
                {/* Current Badge for Free Tier */}
                {tier.name === 'Free' && (
                  <div className="absolute top-0 right-0 bg-gray-200 text-gray-800 text-xs font-bold px-4 py-1 rounded-bl-lg">
                    Current
                  </div>
                )}
                {/* Most Popular Badge */}
                {tier.mostPopular && (
                  <div className="absolute top-0 left-0 bg-pink-500 text-white text-xs font-bold px-4 py-1 rounded-br-lg">
                    Most Popular
                  </div>
                )}
                <div className="p-8">
                  <h3 className="text-xl leading-6 font-bold text-gray-900">
                    {tier.name}
                  </h3>
                  <p className="mt-4 text-2xl font-extrabold text-gray-900">
                    {tier.price}
                  </p>
                  <ul className="mt-6 space-y-4">
                    {tier.features.map((feature, i) => (
                      <li
                        key={i}
                        className="flex items-center text-gray-700"
                      >
                        <svg
                          className="h-5 w-5 text-pink-500"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 4.707 7.293a1 1 0 00-1.414 1.414l5 5a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <span className="ml-3">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <button
                    className={`mt-8 w-full py-2 px-4 rounded-lg text-sm font-semibold text-white ${
                      tier.mostPopular
                        ? 'bg-pink-500 hover:bg-pink-600'
                        : 'bg-gray-800 hover:bg-gray-900'
                    }`}
                  >
                    {tier.button}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}